export enum PlanType {
  LINK_DE_PAGO = 0,
  NORMAL = 1,
  VARIABLE = 2,
  ON_DEMAND = 3
}
